import { createFileRoute } from '@tanstack/react-router'
import { isEntityKind } from '@bloo-team/core-shell'
import { FabricSearchPage, type FabricSearchParams } from '@bloo-team/product-fabric'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): the route
 * infrastructure — path, search-param validation — stays in the app's tree;
 * the surface lives in @bloo-team/product-fabric (and the engine it drives in
 * @bloo-team/core-shell — E7, D14). `?q=&from=&to=` make every search a
 * shareable link; `mode=entity&type=&value=` is the cross-stream entity
 * face (docs/entity-search.md).
 */
function SearchRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <FabricSearchPage clusterId={clusterId} scopeId={scopeId} {...search} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/search')({
  validateSearch: (search: Record<string, unknown>): FabricSearchParams => ({
    q: typeof search.q === 'string' && search.q.trim() ? search.q : undefined,
    from: typeof search.from === 'string' && search.from ? search.from : undefined,
    to: typeof search.to === 'string' && search.to ? search.to : undefined,
    mode: search.mode === 'entity' ? 'entity' : undefined,
    type: isEntityKind(search.type) ? search.type : undefined,
    value: typeof search.value === 'string' && search.value.trim() ? search.value.trim() : undefined,
    window: typeof search.window === 'string' && /^\d+[smhd]$/.test(search.window) ? search.window : undefined,
    raw: search.raw === true || search.raw === 'true' || search.raw === '1' ? true : undefined,
  }),
  component: SearchRoute,
})
